// extracted by mini-css-extract-plugin
export default {"search":"SearchForm_search__hXyIe","searchMarginBottom":"SearchForm_searchMarginBottom__umbPc"};